module.exports = __webpack_public_path__ + "img/qc1_mb.58aa631b.jpg";